
import Highcharts from 'highcharts';
import DrilldownModule from "highcharts/modules/drilldown";
import Chart from "highcharts-react-official";
import { formatarParaMoedaBRL } from "../../utils";

DrilldownModule(Highcharts);
export default function BarChart({
  series,
  seriesDropdown,
  title
}: {
    series: any,
    seriesDropdown: any,
    title:string
}) {
  const options = {
    chart: {
      type: 'column'
  },
  title: {
      text: title
  },
  credits: {
    enabled: false
  },
  subtitle: {
      text: 'Clique nas colunas para mais detalhes'
  },
  accessibility: {
      announceNewData: {
          enabled: true
      }
  },
  xAxis: {
      type: 'category'
  },
  yAxis: {
      title: {
          text: 'Valor consumo'
      }

  },
  legend: {
      enabled: false
  },
  plotOptions: {
      series: {
          borderWidth: 0,
          dataLabels: {
              enabled: true,
              formatter: function (this: Highcharts.TooltipFormatterContextObject) {
                return formatarParaMoedaBRL(Number(this.point.y));
            }
          }
      }
  },

  tooltip: {
      formatter: function (this: Highcharts.TooltipFormatterContextObject) {
        return  '<span style="color:'+this.color+'">'+this.point.name+'</span>: ' +
        '<b>'+formatarParaMoedaBRL(Number(this.point.y))+'</b> consumido<br/>';
    }
      
     
  },

  series: [
      {
          name: 'Clientes',
          colorByPoint: true,
          data: series
      }
  ],
  drilldown: {
      breadcrumbs: {
          position: {
              align: 'right'
          }
      },
      series: seriesDropdown
  }
  };
  
  return (
    <Chart highcharts={Highcharts} options={options} />
  )
}
